// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as Select from "./Select.res.js";
import Moment from "moment";
import * as ReactDates from "react-dates";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Nullable from "@rescript/runtime/lib/es6/Stdlib_Nullable.js";
import * as JsxRuntime from "react/jsx-runtime";

function DayPickerSingleFastNav$MonthYearNav(props) {
  let onYearSelect = props.onYearSelect;
  let onMonthSelect = props.onMonthSelect;
  let month = props.month;
  let thisYear = new Date().getFullYear();
  let monthSections = [{
      items: Stdlib_Array.fromInitializer(12, index => ({
        TAG: "Option",
        key: index.toString(),
        label: I18n.dateTimeFormat(undefined, undefined, undefined, undefined, "long", undefined, undefined, undefined, undefined, new Date(2020, index, 1)),
        value: index
      }))
    }];
  let yearSections = [{
      items: Stdlib_Array.fromInitializer(131, index => {
        let year = (thisYear + 10 | 0) - index | 0;
        return {
          TAG: "Option",
          key: year.toString(),
          label: year.toString(),
          value: year
        };
      })
    }];
  return JsxRuntime.jsxs(Inline.make, {
    children: [
      JsxRuntime.jsx(Select.make, {
        preset: "filter",
        size: "compact",
        sections: monthSections,
        value: {
          TAG: "Single",
          _0: month.month()
        },
        onChange: selection => {
          if (selection.TAG === "Single") {
            return onMonthSelect(month, selection._0.toString());
          }
        }
      }),
      JsxRuntime.jsx(Select.make, {
        preset: "filter",
        size: "compact",
        sections: yearSections,
        value: {
          TAG: "Single",
          _0: month.year()
        },
        onChange: selection => {
          if (selection.TAG === "Single") {
            return onYearSelect(month, selection._0.toString());
          }
        }
      })
    ],
    space: "xsmall",
    align: "center",
    stylex: {
      marginTop: "-2.5px"
    }
  });
}

let MonthYearNav = {
  yearsBack: 120,
  yearsForward: 10,
  make: DayPickerSingleFastNav$MonthYearNav
};

let make = React.memo(props => {
  let isDayBlocked = props.isDayBlocked;
  let onChange = props.onChange;
  let value = props.value;
  let date = Stdlib_Nullable.fromOption(Stdlib_Option.map(value, prim => Moment(prim)));
  let onDateChange = React.useCallback(date => onChange(date.toDate()), [value]);
  let isDayBlocked$1 = React.useCallback(day => Stdlib_Option.mapOr(isDayBlocked, false, fn => fn(day.toDate())), [value]);
  return JsxRuntime.jsx(ReactDates.DayPickerSingleDateController, {
    date: date,
    onDateChange: onDateChange,
    isDayBlocked: isDayBlocked$1,
    transitionDuration: 0,
    noBorder: true,
    focused: true,
    renderMonthElement: param => JsxRuntime.jsx(DayPickerSingleFastNav$MonthYearNav, {
      month: param.month,
      onMonthSelect: param.onMonthSelect,
      onYearSelect: param.onYearSelect
    })
  });
});

export {
  MonthYearNav,
  make,
}
/* make Not a pure module */
